import React from 'react';
import { usePetContext } from '../context/PetContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import {
  Dog,
  Cat,
  Bird,
  Fish,
  Turtle,
  Rabbit,
  ChevronDown,
  Check
} from 'lucide-react';

// Icon mapping for pet types
const petIcons = {
  dog: Dog,
  cat: Cat,
  bird: Bird,
  fish: Fish,
  reptile: Turtle,
  small_pet: Rabbit,
  horse: Dog, // Using Dog as placeholder, could use a horse icon library
  other: Dog
};

const PetSwitcher = ({ variant = "default" }) => {
  const { petType, config, allPetTypes, switchPetType, PET_CONFIGS } = usePetContext();
  
  const CurrentIcon = petIcons[petType] || Dog;
  
  // Use local config if API hasn't loaded yet
  const petTypes = allPetTypes.length > 0 
    ? allPetTypes 
    : Object.entries(PET_CONFIGS).map(([id, cfg]) => ({ id, ...cfg }));

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant={variant === "minimal" ? "ghost" : "outline"} 
          className="flex items-center gap-2"
          data-testid="pet-switcher"
        >
          <CurrentIcon className="w-4 h-4" />
          <span className="hidden sm:inline">{config.name}</span>
          <ChevronDown className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Switch Pet Community</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {petTypes.map((pt) => {
          const Icon = petIcons[pt.id] || Dog;
          const isActive = pt.id === petType;
          
          return (
            <DropdownMenuItem
              key={pt.id}
              onClick={() => switchPetType(pt.id)}
              className={`flex items-center justify-between cursor-pointer ${isActive ? 'bg-primary/10' : ''}`}
              data-testid={`pet-switch-${pt.id}`}
            >
              <div className="flex items-center gap-2">
                <Icon className="w-4 h-4" style={{ color: pt.primaryColor || pt.primary_color }} />
                <span>{pt.name}</span>
              </div>
              {isActive && <Check className="w-4 h-4 text-primary" />}
            </DropdownMenuItem>
          );
        })}
        <DropdownMenuSeparator />
        <div className="px-2 py-1.5 text-xs text-muted-foreground">
          Tip: You can have pets of different types!
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default PetSwitcher;
